export const GET_ORDER = "GET_ORDER";
export const GET_ORDER_FAILURE = "GET_ORDER_FAILURE";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";

export const GET_ORDER_BY_ID = "GET_ORDER_BY_ID";
export const GET_ORDER_BY_ID_FAILURE = "GET_ORDER_BY_ID_FAILURE";
export const GET_ORDER_BY_ID_SUCCESS = "GET_ORDER_BY_ID_SUCCESS";

export const UPDATE_ORDER = "UPDATE_ORDER";
export const UPDATE_ORDER_FAILURE = "UPDATE_ORDER_FAILURE";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";

// ✅ ADD THESE NEW LINES
export const CLEAR_ORDER = "CLEAR_ORDER";

export const CREATE_ORDER = "CREATE_ORDER";
export const CREATE_ORDER_FAILURE = "CREATE_ORDER_FAILURE";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";

export const CREATE_ORDER_COD = "CREATE_ORDER_COD";
export const CREATE_ORDER_COD_FAILURE = "CREATE_ORDER_COD_FAILURE";
export const CREATE_ORDER_COD_SUCCESS = "CREATE_ORDER_COD_SUCCESS";

export const CONFIRM_ORDER = "CONFIRM_ORDER";
export const CONFIRM_ORDER_FAILURE = "CONFIRM_ORDER_FAILURE";
export const CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS";

export const APPLY_COUPON = "APPLY_COUPON";
export const APPLY_COUPON_FAILURE = "APPLY_COUPON_FAILURE";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";